export const data = [
  {
    id: 'Retail',
    data: [
      {
        x: '2019',
        y: 0,
        size: '$392B'
      },
      {
        x: '2020',
        y: -23,
        size: '$302B'
      },
      {
        x: '2021',
        y: -15,
        size: '$334B'
      }
    ]
  },
  {
    id: 'Offline Secondhand',
    data: [
      {
        x: '2019',
        y: 0,
        size: '$21B'
      },
      {
        x: '2020',
        y: -27,
        size: '$15B'
      },
      {
        x: '2021',
        y: 2,
        size: '$21B'
      }
    ]
  },
  {
    id: 'Online Secondhand',
    data: [
      {
        x: '2019',
        y: 0,
        size: '$7B'
      },
      {
        x: '2020',
        y: 27,
        size: '$9B'
      },
      {
        x: '2021',
        y: 69,
        size: '$12B'
      }
    ]
  }
];
